import { useAtomValue } from 'jotai';
import { accountsProductSummaryAtom } from 'src/atoms/filters/product-summary';
import { useAuth } from 'src/auth/hooks/useAuth';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';

export const useProductAccountRef = () => {
  const { user } = useAuth();
  const isCSLUser = useIsCslUser();

  const accountRef = useAtomValue(accountsProductSummaryAtom);

  return isCSLUser ? accountRef : user.referenceId;
};
